export default "__VITE_ASSET__0818fb2f__"